import intl from 'react-intl-universal';
import { useEffect, useState, useRef } from 'react';
import Exhibition, { columnItem } from '../Exhibition';
import Commoditys, { checkType } from './Commoditys';
import AfterSaleGoods from './AfterSaleGoods';
import { Affix, Dropdown, Divider } from 'antd';
import { default as Button } from '@/components/CssBtn';

import type { AfterSalesTypes } from '@/type/common';
import ErrorPrompt from '@/components/ErrorPrompt';

import style from './index.less';
import { cloneDeep, isObject } from 'lodash';

type valueType = { [key: string]: any }[];
interface Props {
    data: any;
    checkType?: checkType; // 默认 ‘checkbox’ none表示不展示选择
    onHandleOperateClick?: (type: string, values: valueType) => void;
    orderColumns: any[];
    commodityColumns?: any[];
    isAfterSaleGoods?: boolean;
    afterSaleGoodsColumns?: any[];
    goodsProblemColumns?: any[];
    orderInfo?: any;
    orderGoodsInfo?: any[];
    // informationColumns?: any[];
    buttonFlag?: boolean;
    buttonList?: any[];
    goodsTitle?: any[];
    repairGoodsTitle?: string;
    // infoBtnText?: any[];
    informationList?: any[];
    problemList?: any[];
    errorFlag?: boolean;
    refreshParams?: any;
    orfreshfunc?: (params?: any, isExpand?: boolean, isFirst?: boolean) => void;
    goodsList?: any[];
    col?: number;
    onClickModal?: (flag: boolean, commoditys: any) => void;
    container?: HTMLDivElement | null;

    children: React.ReactNode;
}

type ButtonConfig = {
    label: string;
    key?: AfterSalesTypes;
    type?:
        | 'link'
        | 'text'
        | 'default'
        | 'ghost'
        | 'primary'
        | 'dashed'
        | undefined;

    children?: ButtonConfig[];

    show?: (data: any) => boolean;
};

const defaultButtons: ButtonConfig[] = [
    {
        label: intl.get('退款'),
        // key:
        children: [
            {
                label: intl.get('仅退款'),
                key: 'ReMoney',
            },
            {
                label: intl.get('退货退款'),
                key: 'ReSales',
            },
            {
                label: intl.get('退运费'),
                key: 'ReCharges',
                show: (data) => {
                    return data.is_can_re_exp_btn;
                },
            },
        ],
    },
    // {
    //     text: '退货退款',
    //     key: 'ReSales',
    // },
    // {
    //     text: '仅退款',
    //     key: 'ReMoney',
    // },
    {
        label: intl.get('换货'),
        key: 'ExSales',
    },
    {
        label: intl.get('维修'),
        key: 'Maintain',
    },
    {
        label: intl.get('补券'),
        key: 'Coupon',
    },
    {
        label: intl.get('补发配件'),
        key: 'Accessory',
    },
    // {
    //     text: '退运费',
    //     key: 'Accessory',
    // },
];

export const orderInfoInits: columnItem[] = [
    {
        label: intl.get('关联工单号'),
        key: 'id',
    },
    {
        label: intl.get('退款方式'),
        key: 'name',
    },
    {
        label: intl.get('售后单发起时间'),
        key: 'name',
    },
];

const Order: React.FC<Props> = (props) => {
    const {
        // data,
        checkType,
        onHandleOperateClick,
        orderColumns,
        commodityColumns = [],
        isAfterSaleGoods = false,
        afterSaleGoodsColumns = [],
        goodsProblemColumns = [],
        orderInfo = {},
        orderGoodsInfo = [],
        // informationColumns = [],
        // informationList = [],
        buttonFlag = true,
        buttonList = [],
        goodsTitle = [],
        repairGoodsTitle = '',
        // infoBtnText = [],
        problemList = [],
        errorFlag = false,
        refreshParams = {},
        orfreshfunc,
        goodsList = [],
        col = 3,
        onClickModal,
        container: propsContainer = null,
    } = props;
    const [checkedCommoditys, setCheckedCommoditys] = useState<valueType>([]);
    const [container, setContainer] = useState<HTMLDivElement | null>(
        propsContainer,
    );
    const affixRef = useRef(null);

    useEffect(() => {
        setContainer(propsContainer);
        if (propsContainer) {
            const handler = () => {
                affixRef.current?.updatePosition();
            };
            window.addEventListener('scroll', handler, true);
            return () => window.removeEventListener('scroll', handler, true);
        }
    }, [propsContainer]);

    const getCheckType = (): checkType => {
        if (checkType) return checkType;
        // FIX: 根据订单信息判断选择类型
        return 'checkbox';
    };

    const handleOperateClick = (type: AfterSalesTypes) => {
        onHandleOperateClick &&
            onHandleOperateClick(type, checkedCommoditys || []);
    };

    const onCommodityCheckChange = (value: any) => {
        const checkedGoods: valueType = [];
        const goods = cloneDeep(orderGoodsInfo);

        goods.forEach((item) => {
            if (isObject(value[item.id])) {
                item.sub_goods_infos = item.sub_goods_infos.filter(
                    (child: any) => {
                        return value[item.id][child.id];
                    },
                );
                if (item.sub_goods_infos?.length) {
                    checkedGoods.push(item);
                }
            } else if (value[item.id]) {
                checkedGoods.push(item);
            }

            return value[item.id];
        });

        setCheckedCommoditys([...checkedGoods]);
    };

    const onRefresh = () => {
        orfreshfunc && orfreshfunc(refreshParams, false, false);
    };

    return (
        <div>
            {errorFlag ? (
                <ErrorPrompt onRefresh={onRefresh} />
            ) : (
                <div>
                    <Exhibition
                        data={orderInfo}
                        columns={orderColumns}
                        config={{ col }}
                    />

                    {container && (
                        <Affix
                            ref={affixRef}
                            target={() => container}
                        >
                            {buttonFlag && (
                                <div className={style.operateContainer}>
                                    {buttonList.length
                                        ? buttonList.map((button, index) => (
                                              <Button
                                                  key={index}
                                                  type={
                                                      button.type || 'primary'
                                                  }
                                                  onClick={() =>
                                                      button.onClick &&
                                                      button.onClick(button.key)
                                                  }
                                                  className={style.button}
                                              >
                                                  {button.text}
                                              </Button>
                                          ))
                                        : defaultButtons.map(
                                              (button, index) => {
                                                  const show =
                                                      button.show?.(
                                                          orderInfo,
                                                      ) || true;
                                                  if (show) {
                                                      return button.children ? (
                                                          <Dropdown
                                                              key={index}
                                                              //   icon={<DownOutlined />}
                                                              //   loading={loadings[1]}
                                                              menu={{
                                                                  items: (
                                                                      button.children ||
                                                                      []
                                                                  ).filter(
                                                                      (i) => {
                                                                          return i.show
                                                                              ? i.show?.(
                                                                                    orderInfo,
                                                                                )
                                                                              : true;
                                                                      },
                                                                  ),
                                                                  onClick: ({
                                                                      key,
                                                                  }) =>
                                                                      handleOperateClick(
                                                                          key,
                                                                      ),
                                                              }}
                                                          >
                                                              <Button
                                                                  type={
                                                                      button.type ||
                                                                      'primary'
                                                                  }
                                                                  className={
                                                                      style.button
                                                                  }
                                                              >
                                                                  {button.label}
                                                              </Button>
                                                          </Dropdown>
                                                      ) : (
                                                          <Button
                                                              key={index}
                                                              type={
                                                                  button.type ||
                                                                  'primary'
                                                              }
                                                              onClick={() =>
                                                                  handleOperateClick(
                                                                      button.key,
                                                                  )
                                                              }
                                                              className={
                                                                  style.button
                                                              }
                                                          >
                                                              {button.label}
                                                          </Button>
                                                      );
                                                  }

                                                  return '';
                                              },
                                          )}
                                </div>
                            )}
                        </Affix>
                    )}
                    {!container && (
                        <div>
                            {buttonFlag && (
                                <div className={style.operateContainer}>
                                    {buttonList.length
                                        ? buttonList.map((button, index) => (
                                              <Button
                                                  key={index}
                                                  type={
                                                      button.type || 'primary'
                                                  }
                                                  onClick={() =>
                                                      button.onClick &&
                                                      button.onClick(button.key)
                                                  }
                                                  className={style.button}
                                              >
                                                  {button.text}
                                              </Button>
                                          ))
                                        : defaultButtons.map(
                                              (button, index) => (
                                                  <Button
                                                      key={index}
                                                      type={
                                                          button.type ||
                                                          'primary'
                                                      }
                                                      onClick={() =>
                                                          handleOperateClick(
                                                              button.key,
                                                          )
                                                      }
                                                      className={style.button}
                                                  >
                                                      {button.text}
                                                  </Button>
                                              ),
                                          )}
                                </div>
                            )}
                        </div>
                    )}
                    <Divider />
                    {!isAfterSaleGoods && (
                        <Commoditys
                            checkType={getCheckType()}
                            data={orderGoodsInfo}
                            onChange={onCommodityCheckChange}
                            commodityColumns={commodityColumns}
                            col={col}
                        />
                    )}
                    {isAfterSaleGoods && (
                        <AfterSaleGoods
                            goodsColumns={afterSaleGoodsColumns}
                            goodsTitle={goodsTitle}
                            repairGoodsTitle={repairGoodsTitle}
                            problemColumns={goodsProblemColumns}
                            problemList={problemList}
                            goodsList={goodsList}
                            onClickModal={onClickModal}
                        />
                    )}
                    {props.children}
                </div>
            )}
        </div>
    );
};

export default Order;
